<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showReviewPartnerInfoSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div class="sb-header-title">Review The Marketpalce</div>
            <div class="sb-header-sub-title">Please ensure all details are correct</div>
        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 200px)'}"
                   [styleClass]="'app-scrollpanel'" *ngIf="!loading">
        <div class="review-partner-block">
            <div class="review-partner-title">Carefully review the partner information.</div>
            <div class="review-partner-subtitle mb-5">This is the final check before the Partner is live on the Xpress Platform!</div>
            <div class="flex-row">
                <div class="col-6 px-0 py-2">
                    Partner Stores:
                </div>
                <div class="col-6 px-0 py-2">
                    <b>{{merchantInfo.CountStores}}</b>
                </div>
            </div>
            <div class="flex-row">
                <div class="col-6 px-0 py-2">
                    Products:
                </div>
                <div class="col-6 px-0 py-2">
                    <b>{{merchantInfo.CountProducts}}</b>
                </div>
            </div>
            <div class="flex-row">
                <div class="col-6 px-0 py-2">
                    Employees:
                </div>
                <div class="col-6 px-0 py-2">
                    <b>{{ merchantInfo.CountEmployees }}</b>
                </div>
            </div>
            <div class="flex-row" *ngFor="let employee of merchantInfo.EmployeesReviewPartnerInfo">
                <div class="col-6 pr-0 py-2 pl-5 text-black-alpha-50">
                    {{employee.XpressAndMerchantUserRole}}
                </div>
                <div class="col-6 px-0 py-2">
                    <b>{{employee.EmployeeCountByRole}}</b>
                </div>
            </div>
            
            <div class="flex-row">
                <div class="col-6 px-0 py-2">
                    Payment:
                </div>
                <div class="col-6 px-0 py-2">
                    <b>{{merchantInfo.Payment ?? 'None'}}</b>
                </div>
            </div>
        </div>
    </p-scrollPanel>
    <ng-template pTemplate="footer">
        <p-divider></p-divider>
        <div class="d-ruby">
            <div class="col-12 p-0 text-end">
                <button class="btn-primary" mat-flat-button color="primary" (click)="beginReview()">Begin Review</button>
            </div>
        </div>
    </ng-template>
</p-sidebar>